import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    DeleteInventoryStockAdjustmentInput,
    DeleteInventoryStockAdjustmentResponse,
} from '../../types/inventory';

const deleteStockAdjustment = async (
    sessionId: string,
    input: DeleteInventoryStockAdjustmentInput,
): Promise<DeleteInventoryStockAdjustmentResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/adjustments/delete`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useDeleteInventoryStockAdjustment = (
    options?: UseMutationOptions<
        DeleteInventoryStockAdjustmentResponse,
        unknown,
        DeleteInventoryStockAdjustmentInput
    >,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: DeleteInventoryStockAdjustmentInput) =>
            deleteStockAdjustment(sessionContext?.sessionId ?? '', input),
        ...options,
    });
};

export function parseInventoryAdjustmentNotDeletableError(
    error: unknown,
): { message: string } | null {
    const response = (error as { response?: { status?: number; data?: unknown } })?.response;
    if (response?.status !== 400) return null;
    const data = response.data as { code?: string; message?: string } | undefined;
    if (data?.code === 'ADJUSTMENT_NOT_DELETABLE') {
        return { message: data.message ?? 'Only the most recent adjustment can be deleted.' };
    }
    return null;
}
